import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TungstenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tungsten"}/>
}
